import { useTranslation } from "react-i18next";

import { Col, Divider, Row } from "antd";
import { InputNumber, Select } from "components/form";
import { ACTION } from "features/payment/schemas/PaymentShemas";

function DoubleShiftForm({ shiftsList = [], values = {} }) {
  const { t } = useTranslation();
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <p className="text-table">{t("shift.label.double_shift_one")} *</p>
        </Col>
        <Col span={6}>
          <p className="text-table">{t("shift.label.double_shift_two")} *</p>
        </Col>
        <Col span={6}>
          <p className="text-table">{t("shift.label.double_shift_three")}</p>
        </Col>
        <Col span={6}>
          <p className="text-table">{t("shift.label.double_shift_wage")}</p>
        </Col>
      </Row>
      <Divider />
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Select name="doubleShiftOneId" size="middle" options={shiftsList} disabled={values?.type === ACTION.VIEW} />
        </Col>
        <Col span={6}>
          <Select name="doubleShiftTwoId" size="middle" options={shiftsList} disabled={values?.type === ACTION.VIEW} />
        </Col>
        <Col span={6}>
          <Select
            name="doubleShiftThreeId"
            size="middle"
            options={shiftsList}
            disabled={values?.type === ACTION.VIEW}
          />
        </Col>
        <Col span={6}>
          <InputNumber name="doubleShiftWage" size="middle" />
        </Col>
      </Row>
    </>
  );
}

export default DoubleShiftForm;
